import { VerticalSigningIcon, CityIcon, EquipmentIcon, HorizontalSigningIcon } from "@l2r-front/l2r-icons"

import { L2rAppCity } from "../../app"

import { I18N_NAMESPACE } from "./i18n"
import { MODULE_EQUIPMENT, MODULE_HORIZONTAL_SIGNING, MODULE_VERTICAL_SIGNING } from "./modules"

export const APP_CITY = "city"

export const appCity = {
    index: 2,
    color: "cta-bg/cta-bg-primary",
    component: <L2rAppCity />,
    icon: CityIcon,
    externalContexts: [],
    i18nNamespace: I18N_NAMESPACE,
    label: "app.label",
    modules: {
        verticalSigning: {
            index: 0,
            icon: VerticalSigningIcon,
            id: "VERTICAL_SIGNING",
            kpis: [],
            label: "app.modules.verticalSigning",
            path: MODULE_VERTICAL_SIGNING,
            urlParams: [],
        },
        horizontalSigning: {
            index: 1,
            icon: HorizontalSigningIcon,
            id: "HORIZONTAL_SIGNING",
            kpis: [],
            label: "app.modules.horizontalSigning",
            path: MODULE_HORIZONTAL_SIGNING,
            urlParams: [],
        },
        equipment: {
            index: 2,
            icon: EquipmentIcon,
            id: "EQUIPMENT",
            kpis: [],
            label: "app.modules.equipment",
            path: MODULE_EQUIPMENT,
            urlParams: [],
        },
    },
    path: APP_CITY,
}